import { SiteManagement } from '~/app/components/site-management/SiteManagement';

export const SiteManagementContainer = () => <SiteManagement />;
